import { render, staticRenderFns } from "./restBookSummarySet.vue?vue&type=template&id=3e125a98&scoped=true&"
import script from "./restBookSummarySet.vue?vue&type=script&lang=js&"
export * from "./restBookSummarySet.vue?vue&type=script&lang=js&"
import style0 from "./restBookSummarySet.vue?vue&type=style&index=0&id=3e125a98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e125a98",
  null
  
)

export default component.exports